import React, { useState } from 'react';
export const RE_DIGIT = /^\d+$/;
import './InputButtonPlace.scss';

const InputButtonPlace = ({
  length = 6,
  value = '',
  onChange,
}) => {
  const getValueItems = (data) => {
    const valueArray = data;
    const items = [];
    for (let i = 0; i < length; i += 1) {
      const char = valueArray[i];
      if (RE_DIGIT.test(char)) {
        items.push(char);
      } else {
        items.push('');
      }
    }
    return items;
  };
  const [valueItems, setValueItems] = useState(getValueItems(value));

  const inputOnChange = (e, idx) => {
    const { target } = e;
    let targetValue = target.value.trim();
    const isTargetValueDigit = RE_DIGIT.test(targetValue);
    if (!isTargetValueDigit && targetValue !== '') {
      return;
    }
    targetValue = isTargetValueDigit ? targetValue : ' ';
    const targetLength = targetValue.length;
    if (targetLength === 1) {
      const newValue = valueItems;
      newValue[idx] = targetValue;
      setValueItems([...getValueItems(newValue)]);
      onChange(newValue);
      if (!isTargetValueDigit) {
        return;
      }
      const nextElementSibling = target.nextElementSibling || null;
      if (nextElementSibling) {
        nextElementSibling.focus();
      }
    } else if (targetLength === length) {
      const newValue = targetValue.split('').map((char) => char);
      setValueItems([...getValueItems(newValue)]);
      onChange(newValue);
      target.blur();
    }
  };
  const inputOnKeyDown = (e) => {
    const { target } = e;
    const targetValue = target.value;
    target.setSelectionRange(0, targetValue.length);
    if (e.key !== 'Backspace' || target.value !== '') {
      return;
    }
    const previousElementSibling = target.previousElementSibling || null;
    if (previousElementSibling) {
      previousElementSibling.focus();
    }
  };

  const inputOnFocus = (e) => {
    const { target } = e;
    target.setSelectionRange(0, target.value.length);
  };


  return (
    <div className="inputButtonPlace">
      {valueItems.map((digit, idx) => {
        const key = `otp-input-${idx}`;
        return (
          <input
            className={`valuessd${idx} eachItem`}
            key={key}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="\d{1}"
            maxLength={length}
            value={digit}
            onChange={(e) => inputOnChange(e, idx)}
            onKeyDown={inputOnKeyDown}
            onFocus={inputOnFocus}
            data-cy={key}
          />
        );
      })}
    </div>
  );
};

export default InputButtonPlace;

 